import { styled, Button } from '@mui/material';

export const ViewAllBtn = styled(Button)`
    width: 90px;
    height: 32px;
    background: #e8f4ff;
    color: #1890ff;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 700;
    &:hover {
        background: #e8f4ff;
    }
`;
